import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { retry, catchError } from 'rxjs/operators';
import { environment } from "../../../../environments/environment";



@Injectable({
  providedIn: 'root'
})
export class FilterService {
// URL API
apiURL = environment.apiUrl;

  constructor(private http: HttpClient) { 

  }
 
  getCampos(){
    return this.http.get(this.apiURL + '/getformulariocapturacampo')
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  getActivos(){
    return this.http.get(this.apiURL + '/getformulariocaptura')
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

  getCamposResultado(formCapId){
    return this.http.get(this.apiURL + '/getFormularioCapturaCampoParm?formulario_captura_id='+formCapId)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
  }

getActivosResultados(formCapId){
  return this.http.get(this.apiURL + /formulario_captura/ + formCapId)
    .pipe(
      retry(1),
      catchError(this.handleError)
    );
}



  handleError(error) {

    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Hay un error en la busqueda debido al servidor!\nCodigo Error: ${error.status}\nMessage: ${error.message}`;
      window.location.reload();
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

}
